import { CustomerIntegrationController } from "@gaming/srvg-classes-core";
import { messageDataParse } from "./messageDataParse";
import { openStats } from "./openStats";

declare global {
    interface Window {
        srvg: {
            customerIntegration: CustomerIntegrationController
        };       
    }
}

export const postMessageHandler = (event: MessageEvent) => {
    const { type, data } = messageDataParse(event.data);
    switch (type) {
        case 'setSelectedMatchday':
            srvg.customerIntegration.setSelectedMatchday(data?.matchday, !!data?.nextSeason);
            break;
        case 'setSelectedMatchdayByTimestamp':
            srvg.customerIntegration.setSelectedMatchdayByTimestamp(data);
            break;
        case 'openStats':
            openStats(data?.competitor1, data?.competitor2, data?.seasonId);
            break;
        default:
            break;
    }
}